import React, { useState, useEffect } from "react";
import ReactTable from "react-table";

import { customToast as toast } from "../../utils";

import ActivityService from "../../services/activityService";
import Loading from "../common/Loading";

export const useActivities = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await ActivityService.getAllActivity();
        if (result.data) {
          setData(result.data);
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
        toast.error(err.message);
      }
    };
    fetchData();
  }, []);
  return { data, loading };
};

const ActivityList = () => {
  const { data, loading } = useActivities();
  const columns = [
    {
      id: "user",
      Header: "User",
      accessor: "user.full_name"
    },
    {
      id: "timestamp",
      Header: "Timestamp",
      accessor: "created_at",
      Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "")
    },
    {
      id: "ip",
      Header: "IP Address",
      accessor: "ip"
    },
    {
      id: "userAgent",
      Header: "User Agent",
      accessor: "userAgent"
    },
    {
      id: "action",
      Header: "Action",
      accessor: "action"
    }
  ];

  return (
    <div>
      <ReactTable
        className="-highlight"
        data={data}
        resizable
        loading={loading}
        LoadingComponent={() => <Loading active={loading} />}
        columns={columns}
        defaultPageSize={10}
        defaultSorted={[
          {
            id: "timestamp",
            desc: true
          }
        ]}
      />
    </div>
  );
};

export default ActivityList;
